import React from 'react';
import { TbFileDownload } from "react-icons/tb";

const CONTENT = {
  en: {
    leftTitle: "You don't need to hire someone <br/> to find leads for you. <br/>We give you the list and you <br/> take it from there.",
    leftBody: "With our commercial cleaning-specific contact list, you're in control of your lead generation. Whether you're offering office cleaning, medical facility disinfecting, or industrial deep cleans,our verified data helps you connect with the right decision-makers faster.",
    rightTitle: "See a sample of you what you'll get",
    howItWorks: "How It Works",
    question: "A common question. What specific industries are included?",
    industries: "Mining, Construction, Manufacturing, Transportation, Communications, Utilities, Wholesalers, Retailers, Finance, Insurance, And Real Estate offices, and Service Providers (except schools and government offices). ",
    niche: "Too many niche business types to list!",
    knowThis: "Know this: ",
    knowThisEnd: " if we know how big their office is, how many employees they have, and if we can see their website, they're included! We've been making lists like this for decades. We know this one works. ",
    cta: " Download the sample list to see an example, or just put in your ZIP code and get started today! ",
    clickToDownload: "Click to Download",
    sampleFile: "Sample File",
  },
  es: {
    leftTitle: "No necesitas contratar a nadie para buscar clientes potenciales. Nosotros te damos la lista y tú sigues desde ahí.",
    leftBody: "Con nuestra lista de contactos específica para limpieza comercial, tú controlas la generación de leads. Ya sea que ofrezcas limpieza de oficinas, desinfección de instalaciones médicas o limpieza profunda industrial, nuestros datos verificados te ayudan a conectar con los responsables de decisiones más rápido.",
    rightTitle: "Mira una muestra de lo que obtendrás",
    howItWorks: "Cómo funciona",
    question: "Una pregunta común. ¿Qué industrias específicas están incluidas?",
    industries: "Minería, construcción, manufactura, transporte, comunicaciones, servicios públicos, mayoristas, minoristas, finanzas, seguros, oficinas de bienes raíces y proveedores de servicios (excepto escuelas y oficinas gubernamentales).",
    niche: "¡Demasiados tipos de negocios de nicho para listar!",
    knowThis: "Ten esto en cuenta: ",
    knowThisEnd: "si sabemos qué tan grande es su oficina, cuántos empleados tienen y si podemos ver su sitio web, ¡están incluidos! Llevamos décadas haciendo listas así. Sabemos que esta funciona. ",
    cta: " Descarga la lista de muestra para ver un ejemplo, o simplemente ingresa tu código postal y comienza hoy. ",
    clickToDownload: "Haz clic para descargar",
    sampleFile: "Archivo de muestra",
  },
};

const GrowBusiness = ({ lang = "en", onSampleDownloadClick }) => {
  const t = CONTENT[lang] || CONTENT.en;
const data = [
  { firstName: "SAMPLE", lastName: "SAMPLE", title: "MEMBER", email: "SAMPLE", companyName: "MYHOMEDIA  LLC", address1: "4350 MAIN ST STE 115", address2: "", city: "FRISCO", state: "TX", zipcode: "75033", zip4: "SAMPLE", phone: "SAMPLE", sicCode: "17310303", industryKeyword: "SOUND EQUIPMENT SPECIALIZATION", employeeSize: "SAMPLE", revenue: "SAMPLE", companyType: "Stand Alone", squareFootage: "1900", yearStarted: "2005", url: "SAMPLE" },
  { firstName: "SAMPLE", lastName: "SAMPLE", title: "OWNER", email: "SAMPLE", companyName: "MARCUS WHITMORE DDS", address1: "5932 W PARKER RD STE 600", address2: "", city: "PLANO", state: "TX", zipcode: "75093", zip4: "SAMPLE", phone: "SAMPLE", sicCode: "80210202", industryKeyword: "DENTISTS OFFICE", employeeSize: "SAMPLE", revenue: "SAMPLE", companyType: "Stand Alone", squareFootage: "2323", yearStarted: "1984", url: "SAMPLE" },
  { firstName: "SAMPLE", lastName: "SAMPLE", title: "PRINCIPAL", email: "SAMPLE", companyName: "TWIN LAKES PET & BIRD CLINIC", address1: "26810 US HIGHWAY 380 E", address2: "", city: "AUBREY", state: "TX", zipcode: "76227", zip4: "SAMPLE", phone: "SAMPLE", sicCode: "7429901", industryKeyword: "ANIMAL HOSPITAL SERVICES PETS AND OTHER ANIMAL SPECIALTIES", employeeSize: "SAMPLE", revenue: "SAMPLE", companyType: "Stand Alone", squareFootage: "3326", yearStarted: "2005", url: "SAMPLE" },
  { firstName: "SAMPLE", lastName: "SAMPLE", title: "PRESIDENT", email: "SAMPLE", companyName: "AXXYS TECHNOLOGIES  INC", address1: "5601 GRANITE PKWY STE 100", address2: "", city: "PLANO", state: "TX", zipcode: "75024", zip4: "SAMPLE", phone: "SAMPLE", sicCode: "73790200", industryKeyword: "COMPUTER RELATED CONSULTING SERVICES", employeeSize: "SAMPLE", revenue: "SAMPLE", companyType: "Stand Alone", squareFootage: "3500", yearStarted: "1987", url: "SAMPLE" },
  { firstName: "SAMPLE", lastName: "SAMPLE", title: "PRESIDENT", email: "SAMPLE", companyName: "STUDIO 3 DANCE", address1: "2220 COIT RD STE 440", address2: "", city: "PLANO", state: "TX", zipcode: "75075", zip4: "SAMPLE", phone: "SAMPLE", sicCode: "79110203", industryKeyword: "DANCE STUDIO AND SCHOOL", employeeSize: "SAMPLE", revenue: "SAMPLE", companyType: "Stand Alone", squareFootage: "5000", yearStarted: "1997", url: "SAMPLE" },
  { firstName: "SAMPLE", lastName: "SAMPLE", title: "CHAIRMAN OF THE BOARD", email: "SAMPLE", companyName: "STEELFAB TEXAS  INC", address1: "304 CENTRAL EXPY S", address2: "", city: "ALLEN", state: "TX", zipcode: "75013", zip4: "SAMPLE", phone: "SAMPLE", sicCode: "34410000", industryKeyword: "FABRICATED STRUCTURAL METAL", employeeSize: "SAMPLE", revenue: "SAMPLE", companyType: "Head Quarters", squareFootage: "5500", yearStarted: "1978", url: "SAMPLE" },
  { firstName: "SAMPLE", lastName: "SAMPLE", title: "PRESIDENT", email: "SAMPLE", companyName: "TOOTHACRES KENNELS INC", address1: "1639 PARKER RD", address2: "P O BOX 118916", city: "CARROLLTON", state: "TX", zipcode: "75010", zip4: "SAMPLE", phone: "SAMPLE", sicCode: "7520303", industryKeyword: "TRAINING SERVICES PET AND ANIMAL SPECIALTIES NOT HORSES", employeeSize: "SAMPLE", revenue: "SAMPLE", companyType: "Stand Alone", squareFootage: "3706", yearStarted: "1967", url: "SAMPLE" },
  { firstName: "SAMPLE", lastName: "SAMPLE", title: "PRESIDENT", email: "SAMPLE", companyName: "XTREME PDR  INC", address1: "6447 PRESTON RD", address2: "P O BOX 3016", city: "FRISCO", state: "TX", zipcode: "75034", zip4: "SAMPLE", phone: "SAMPLE", sicCode: "50130100", industryKeyword: "AUTOMOTIVE SUPPLIES AND PARTS", employeeSize: "SAMPLE", revenue: "SAMPLE", companyType: "Stand Alone", squareFootage: "3112", yearStarted: "2004", url: "SAMPLE" },
  { firstName: "SAMPLE", lastName: "SAMPLE", title: "PRESIDENT", email: "SAMPLE", companyName: "PARK WEST CLEANERS INC", address1: "2220 COIT RD STE 470", address2: "", city: "PLANO", state: "TX", zipcode: "75075", zip4: "SAMPLE", phone: "SAMPLE", sicCode: "72169901", industryKeyword: "CLEANING AND DYEING EXCEPT RUGS", employeeSize: "SAMPLE", revenue: "SAMPLE", companyType: "Stand Alone", squareFootage: "2600", yearStarted: "1993", url: "SAMPLE" },
  { firstName: "SAMPLE", lastName: "SAMPLE", title: "BRANCH MANAGER", email: "SAMPLE", companyName: "KSA ENGINEERS  INC", address1: "8866 SYNERGY DR", address2: "", city: "MCKINNEY", state: "TX", zipcode: "75070", zip4: "SAMPLE", phone: "SAMPLE", sicCode: "87110402", industryKeyword: "CIVIL ENGINEERING", employeeSize: "SAMPLE", revenue: "SAMPLE", companyType: "Branch", squareFootage: "1853", yearStarted: "0", url: "SAMPLE" }
];

const generateCSV = () => {
  if (typeof onSampleDownloadClick === "function") {
    onSampleDownloadClick();
  }

  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("sample-file-download-click", {
        detail: { source: "grow-business" }
      })
    );
  }

  const headers = [
    "First Name", "Last Name", "Title", "Email", "Company Name", "Address 1", "Address 2",
    "City", "State", "Zipcode", "ZIP4", "Phone", "Sic Code", "Industry Keyword",
    "Employee Size", "Revenue", "Company Type", "Square Footage", "Year Started", "URL"
  ];

  // Convert objects to CSV rows
  const rows = data.map(row =>
    [
      row.firstName, row.lastName, row.title, row.email, row.companyName, row.address1,
      row.address2, row.city, row.state, row.zipcode, row.zip4, row.phone, row.sicCode,
      row.industryKeyword, row.employeeSize, row.revenue, row.companyType,
      row.squareFootage, row.yearStarted, row.url
    ].join(',')
  );

  // Combine headers and rows
  const csvContent = [headers.join(','), ...rows].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'CommercialCleaningLeadsForYouSampleFile2025.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        {/* <div className="text-center mb-8">
          <p className="text-3xl font-bold text-[#1465B7] mb-4">
            Grow Your Commercial Cleaning Business – <span className='text-[#26A94A]'> Your Way </span>
          </p>
          <p className="text-[#2D4B6A] text-2xl mx-auto">
            You get the list. You take the lead. We make sure it's the right data for you
          </p>
        </div> */}
        <div className="grid md:grid-cols-2 gap-16 max-w-5xl mx-auto">
          {/* Left Card */}
          <div className="bg-[#E4F7F9] p-8 rounded-2xl shadow-lg border-3 border-[#30A61D] text-center">
            <p className="text-2xl text-[#26A94A] font-bold mb-4" dangerouslySetInnerHTML={{ __html: t.leftTitle }} />
            <p className="text-[#314F6D] text-lg leading-relaxed">
              {t.leftBody}
            </p>
          </div>

          {/* Right Card */}
          <div className="bg-[#E4F7F9] p-8 rounded-2xl shadow-lg text-center border-3 border-[#30A61D]">
            <p className="text-2xl font-bold text-[#26A94A] mb-4 uppercase">
              {t.rightTitle}
            </p>
            <div className="flex flex-col items-center mb-6">
              <div className="w-32 h-32 rounded-full flex items-center justify-center mt-12">
                <button
                  onClick={generateCSV}
                  className="flex flex-col items-center cursor-pointer group"
                  aria-label={`${t.clickToDownload} ${t.sampleFile}`}
                >
                  <TbFileDownload className="w-32 h-32 text-[#26A94A] transition-opacity group-hover:opacity-90" />
                  <span className="text-[#1465B7] text-center font-semibold mt-2 text-lg leading-tight">
                    {t.clickToDownload}<br />{t.sampleFile}
                  </span>
                </button>
              </div>
            </div>
            {/* <p className='text-[#314F6D] text-base'>* disclaimer</p> */}
          </div>
        </div>
                 <div className='container mx-auto mt-24 max-w-5xl'>
              <h2 className='text-[#1465B7] text-2xl font-semibold text-center'>{t.howItWorks}</h2>
               <div className="w-full flex justify-center mt-4">
  <div className="w-full aspect-video">
    <iframe
      className="w-full h-[500px]"
      src="https://www.youtube.com/embed/fw8_97UluW8"
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    />
  </div>
</div>
  <div>
    <p className="text-xl font-bold text-[#1465B7]">{t.question}</p>
    <p className="text-[#1465B7] text-base leading-6">{t.industries}</p>
    <p className="text-base text-[#1465B7]">{t.niche}</p>
     <p className="text-[#1465B7] text-base leading-6"><span className="font-bold">{t.knowThis}</span>{t.knowThisEnd}<span className="font-bold">{t.cta}</span>
</p>
    </div>
              </div>
      </div>
    </section>
  );
};

export default GrowBusiness;